import { connect } from 'react-redux';

import { ObjectFotorama } from './ObjectFotorama';
import { photosMapper } from '../../../selectors/fotorama';
import { IState } from '../../../store';
import { INewobjectCategorySchema } from '../../../types';
import { IFotoramaProps, IFotoramaStoreProps } from '../../Fotorama';

type TStoreProps = Pick<IFotoramaStoreProps, 'slides'>;

type TDispatchProps = Pick<
  IFotoramaProps,
  'onElementShowed' | 'onInitialized' | 'onPlayVideo' | 'onStopVideo' | 'onFullScreenToggle' | 'onSlide'
>;

export function mapStateToProps(state: IState, ownProps: IObjectGalleryContainerOwnProps) {
  const { newObjectCategorySetItem: item } = ownProps;

  return {
    slides: item?.additionalGallery?.imageList ? item.additionalGallery.imageList.map(photosMapper) : [],
  };
}

export function mapDispatchToProps() {
  return {
    onElementShowed: () => {},
    onInitialized: () => {},
    onPlayVideo: () => {},
    onStopVideo: () => {},
    onFullScreenToggle: () => {},
  };
}

export interface IObjectGalleryContainerOwnProps {
  newObjectCategorySetItem?: INewobjectCategorySchema;
}

export const ObjectFotoramaContainer = connect<TStoreProps, TDispatchProps, IObjectGalleryContainerOwnProps>(
  mapStateToProps,
  mapDispatchToProps,
)(ObjectFotorama);
